export const MULTIPLE_VEHICLES = 'MULTIPLE_VEHICLES';
export const HOMEOWNER = 'HOMEOWNER';
export const GOOD_DRIVER = 'GOOD_DRIVER';

export const PLACEMENT = {
  offers: 'MORPHEUS_OFFERS',
  overview: 'MORPHEUS_OVERVIEW',
  public: 'MORPHEUS_PUBLIC_PAGE',
};

export const AUTO_INSURANCE_CHECK_BOX_GROUP = [
  { value: MULTIPLE_VEHICLES, label: 'Multiple vehicles' },
  { value: GOOD_DRIVER, label: 'Good driver' },
  { value: HOMEOWNER, label: 'Homeowner' },
];

export const initializeCheckBox = (userInfo, creditInfo) => {
  const checkList = [];
  if (userInfo?.homeOwnerStatus === HOMEOWNER) {
    checkList.push(HOMEOWNER);
  }

  if (creditInfo?.creditScoreAnalysis?.accountMix?.autoLoans >= 2) {
    checkList.push(MULTIPLE_VEHICLES);
  }
  return checkList;
};

export const addCheckBoxListFromInsuranceFormData = (
  insuranceFormData,
  checkGoodDriver,
) => {
  const checkFormList = [];
  if (insuranceFormData.homeowner) {
    checkFormList.push(HOMEOWNER);
  }
  if (insuranceFormData.multipleVehicles) {
    checkFormList.push(MULTIPLE_VEHICLES);
  }
  if (insuranceFormData.goodDriver || checkGoodDriver) {
    checkFormList.push(GOOD_DRIVER);
  }
  return checkFormList;
};
